module.exports = __webpack_public_path__ + "static/media/signage-indoor-img4.6ceff15c.jpg";